import axios from 'axios'
import store from './store/index'
import _ from 'lodash';
import vm from 'vue'
import wx from 'weixin-js-sdk';
let state = store.state
let commom = {
  install(Vue, options) {
        Vue.prototype.commom = {
            blurAdjust() {
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                    document.activeElement.scrollIntoViewIfNeeded(true);
                }
            },
            uuid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            compareVerson(versionNum, oldVersionNum) {
                let verson = 136;
                if (oldVersionNum) {
                    verson = oldVersionNum;
                }
                if (versionNum) {
                    let arr1 = versionNum.split("V")[1];
                    let newVerson = arr1.split(".")[0] + "" + arr1.split(".")[1] + "" + arr1.split(".")[2];
                    if (parseInt(newVerson) >= parseInt(oldVersionNum)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            wechatShare() {
                let oDiv = document.createElement('div');
                oDiv.style.background = "#000";
                oDiv.style.opacity = 0.5;
                oDiv.style.position = "fixed";
                oDiv.style.left = 0;
                oDiv.style.top = 0;
                oDiv.style.zIndex = "100";
                oDiv.style.width = "100%";
                oDiv.style.height = "100%";
                oDiv.setAttribute("id", "shareImgDiv");
                let oImg = document.createElement('img');
                oImg.src = "./static/helper.png";
                oImg.style.width = "100%";
                oImg.style.position = "absolute";
                oImg.style.right = 0;
                oImg.style.top = 0;
                oImg.setAttribute("id", "shareImg");
                oDiv.appendChild(oImg);
                document.body.appendChild(oDiv);
                document.getElementById("shareImg").onclick = function() {
                    document.body.removeChild(oDiv);
                }
                document.getElementById("shareImgDiv").onclick = function() {
                    document.body.removeChild(oDiv);
                }
            },
            isWeiXin() {
                //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if (ua.match(/MicroMessenger\/[0-9]/i)) {
                    return true;
                } else {
                    return false;
                }
            },
            isQQ() {
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if (ua.match(/QQ\/[0-9]/i)) {
                    return true;
                } else {
                    return false;
                }
            },
            qqReady() {
                let shareLink = window.location.href.split("#")[0] + `#/shareView?taskId=${Vue.prototype.Global.taskId}&domainCode=A0&taskType=1&taskRang=${Vue.prototype.Global.taskRang}&taskName=${encodeURIComponent(Vue.prototype.Global.taskName)}`;
                let summary = Vue.prototype.Global.desc ? Vue.prototype.Global.desc : "推荐一门好课";
                setShareInfo({
                    title: Vue.prototype.Global.taskName,
                    summary: summary,
                    pic: Vue.prototype.coverPic ? state.downloadpath + Vue.prototype.coverPic + "!100x100" : "https://demo.gkgzj.com/manager-intf/static/gklogo.png",
                    url: shareLink
                });
            },
            /**
             *
             * @param {String, Number} type 是否使用自定义链接
             * @param {String} descs 分享描述
             * @param {String} taskName 分享标题
             * @param {String} coverPic 分享图片
             * @param {String, Number} taskId
             * @param {String} taskRang
             * @param {String} diyUrl
             * @param {String} comName 医院名称
             * @param {String} comId 医院ID
             * @param {Object} urlData 需要拼接的其他参数
             */
            weiXinReady(type, descs, taskName, coverPic, taskId, taskRang, callback, diyUrl, comName, comId, urlData) {
                console.log(arguments);
              console.log(wx,'wx6666');
                let urlParams = '';
                let baseUrlData = urlData || {};
                if (_.isObject(urlData)) {
                    for (let key in urlData) {
                        urlParams += `&${key}=${urlData[key]}`
                    }
                }
                let testshareLink = window.location.href.split("#")[0] + `?#/shareView?taskId=${taskId}&domainCode=A0&taskType=1&taskRang=${taskRang}&taskName=${encodeURIComponent(taskName)}&comName=${comName}&comId=${comId}${urlParams}`;
                console.log(Vue.prototype.Global.isShareAllow)
                const debug = process.env.NODE_ENV != 'production'
                let apiVersion = "/education-intf/api";
                let shareUrl = window.location.href.split("#")[0];
                // https://dygk.gkgzj.com/activity/#/brandPublicity
                // shareUrl = 'https://demo.gkgzj.com/manager-intf/'
                // let shareUrl = 'https://dygk.gkgzj.com/activity/'
                // shareUrl = 'https://dygk.gkgzj.com/activity/'
                console.log(shareUrl,'分享地址1112222');
                axios({
                    method: 'post',
                    timeout: 10000,
                    url: apiVersion + "/wxAccount/getShareTicket",
                    data: { data: { shareUrl: encodeURIComponent(shareUrl) } },
                    headers: state.header.headers
                }).then(
                    (response) => {
                        wx.config({
                            debug: false, ////生产环境需要关闭debug模式
                            appId: response.data.data.appId, //appId通过微信服务号后台查看
                            timestamp: response.data.data.timestamp, //生成签名的时间戳
                            nonceStr: response.data.data.nonceStr, //生成签名的随机字符串
                            signature: response.data.data.signature, //签名
                            jsApiList: [ //需要调用的JS接口列表
                                'checkJsApi',
                                'onMenuShareTimeline',
                                'onMenuShareAppMessage',
                                'hideMenuItems'
                            ]
                        });

                        wx.ready(function() {
                            if (window.location.href.indexOf('/myPrize') != -1) {
                              console.log('抽奖核销页隐藏传播类按钮');
                              wx.hideMenuItems({
                                menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:copyUrl","menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                              });
                            } else {
                                wx.hideMenuItems({
                                    menuList: ["menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                                });
                                //1为自定义参数，2为当前链接, 3为自定义链接
                                // window.location.href.split("#")[0];
                                // let shareLink = window.location.href;
                                let shareLink = window.location.href.split("#")[0];
                                // shareLink = 'https://dygk.gkgzj.com/activity/'
                                if (type == 1) {
                                    let urlParams = '';
                                    if (_.isObject(urlData)) {
                                        for (let key in urlData) {
                                            if (key !== 'taskType') {
                                                urlParams += `&${key}=${urlData[key]}`
                                            }
                                        }
                                    }
                                    shareLink = window.location.href.split("#")[0] + `?#/shareView?taskId=${taskId}&domainCode=A0&taskType=${baseUrlData.taskType || 1}&taskRang=${taskRang}&taskName=${encodeURIComponent(taskName)}&comName=${encodeURIComponent(comName)}&comId=${comId}${urlParams}`;
                                }
                                if (type == 3) {
                                    shareLink = diyUrl;
                                }
                                // shareLink = 'https://dygk.gkgzj.com/activity/'
                                console.log(shareLink,'分享地址2');
                                let desc = descs ? descs : "快速了解感控工作间";
                                let config = {
                                    title: taskName, // 分享标题
                                    desc: desc, // 分享描述
                                    link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                    // imgUrl: coverPic ? state.downloadpic + coverPic + "!100x100" : "https://demo.gkgzj.com/manager-intf/static/gklogo.png", // 自定义图标
                                    imgUrl: "https://demo.gkgzj.com/manager-intf/static/gklogo.png", // 自定义图标
                                    type: 'link', // 分享类型,music、video或link，不填默认为link
                                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                                    success: function() {
                                        // 用户确认分享后执行的回调函数
                                        console.log(config,'wxconfig6666')
                                        callback()
                                    },
                                    cancel: function() {
                                        // 用户取消分享后执行的回调函数
                                    }
                                };
                                wx.onMenuShareTimeline(config);
                                wx.onMenuShareAppMessage(config);
                            }
                            wx.error(function(res) {
                                console.log(res.errMsg);
                            });
                        });
                    }
                ).catch((err) => {})
            }
        }
    }
}
export default commom;
